import React from 'react';
import { ConfirmPopup } from '../../molecules';
import type { CreditCardConditionModel } from '../../../tsrestapi/models';

const tr = require('ts-translate-js').default.boundTR;

interface MembershipCardConditionPopupProps {
    container: any,
    creditCardCondition: CreditCardConditionModel,
    onConfirmPaidWithCreditCardCondition: () => void,
    onPopupClose: () => void
}
    
export function MembershipCardConditionPopup({ container, creditCardCondition, onConfirmPaidWithCreditCardCondition, onPopupClose }: MembershipCardConditionPopupProps) {    

    
    return <ConfirmPopup
            container={container}
            confirmLabel={tr("Je paie avec {name}", { name: creditCardCondition.name[tsapp.twoLetterLang] })}
            title={creditCardCondition.name[tsapp.twoLetterLang]}
            messagehtml={creditCardCondition.explanationText[tsapp.twoLetterLang]}
            onConfirm={onConfirmPaidWithCreditCardCondition}
            onCancel={onPopupClose} 
        />;
}